import { useState } from 'react';

const YouTubeDownloader = () => {
  const [videoUrl, setVideoUrl] = useState('');
  const [loading, setLoading] = useState(false);

  const handleDownload = () => {
    if (!videoUrl) return;

    setLoading(true);
    const serverUrl = 'http://localhost:3001/download';

    const link = document.createElement('a');
    link.href = `${serverUrl}?url=${encodeURIComponent(videoUrl)}`;
    link.target = '_blank';
    link.click();

    setLoading(false);
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>YouTube Video Downloader</h2>
      <input
        type="text"
        placeholder="Paste YouTube video link here..."
        value={videoUrl}
        onChange={(e) => setVideoUrl(e.target.value)}
        style={{ width: '80%', padding: '10px', marginBottom: '10px' }}
      />
      <button
        onClick={handleDownload}
        disabled={!videoUrl || loading}
        style={{
          padding: '10px 20px',
          background: !videoUrl || loading ? '#ccc' : '#007bff',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: !videoUrl || loading ? 'not-allowed' : 'pointer',
        }}
      >
        {loading ? 'Downloading...' : 'Download Video'}
      </button>
    </div>
  );
};

export default YouTubeDownloader;
